import type { Editor } from '@tiptap/react';

export const resetSelection = (editor: Editor) => {
  const { selection } = editor.state;
  const { from } = selection;

  const nodeStartPos = editor.view.state.doc.resolve(from).start();
  editor.commands.setTextSelection({ from: nodeStartPos, to: nodeStartPos });
};
